<div class="container" *ngIf="isOrder">
  <div class="header" [class.header__zindex]="isIndex" [ngClass]="{'v2': featureV2}" *ngIf="featureV2">
    <div *ngFor="let item of listHeaders; let i = index" class="tbl-header tbl-{{item.nameClass}}" id="{{item.className}}">
      <div class="ipt" *ngIf="item.data === 'input' && isCheckbox">
        <lib-input-checkbox class="input-control" id="select-all" name="select-all"></lib-input-checkbox>
      </div>
      <p class="text-header" [class.text-header__v2]="!featureV2" *ngIf="item.data !== 'input'">{{ item.data }}</p>
      <img src="../../../../assets/svgs/icon_order_down_up.svg" alt="Seta" 
      *ngIf="(columnId != i || countColumn === 0) && item.data !== 'input' && item.data !== 'Contato' && item.data !== 'Indicadores' && item.data !== 'Data'">
      <!-- up -->
      <img src="../../../../assets/svgs/icon_order_up.svg" alt="Seta para baixo" 
      *ngIf="(columnId === i && countColumn === 1) && item.data !== 'input' && item.data !== 'Contato' && item.data !== 'Indicadores' && item.data !== 'Data'">
      <!-- down -->
      <img src="../../../../assets/svgs/icon_order_down.svg" alt="Seta para baixo" 
      *ngIf="(columnId === i && countColumn === 2) && item.data !== 'input' && item.data !== 'Contato' && item.data !== 'Indicadores' && item.data !== 'Data'">
    </div>
  </div>
</div>

<div class="container" (scroll)="getScroll($event)" *ngIf="!isOrder">
  <!-- DEFAULT -->
  <div class="header" [class.header__zindex]="isIndex" *ngIf="!featureV2">
    <div *ngFor="let item of listHeaders; let i = index" class="tbl-header tbl-{{item.nameClass}}">
      <p class="text-header" *ngIf="item.data !== 'input'">{{ item.data }}</p>
    </div>
  </div>

  <!-- FEATURE V2 -->
  <div class="header" [class.header__zindex]="isIndex" [ngClass]="{'v2': featureV2, 'removi-checkbox-prod': !isCheckbox }" *ngIf="featureV2">

    <div *ngFor="let item of listHeaders; let i = index" class="tbl-header tbl-{{item.nameClass}}" (click)="actionHeader($event, i)" id="{{item.className}}">
      
      <div class="ipt" *ngIf="item.data === 'input' && isCheckbox" (click)="actionHeader($event, null)">
        <lib-input-checkbox class="input-control" id="select-all" name="select-all" (click)="selectAll()"></lib-input-checkbox>
      </div>
      
      <p class="text-header" [class.text-header__v2]="!featureV2" *ngIf="item.data !== 'input'">{{ item.data }}</p>
      <img src="../../../../assets/svgs/icon_order_down_up.svg" alt="Seta" 
      *ngIf="(columnId != i || countColumn === 0) && item.data !== 'input' && item.data !== 'Contato' && item.data !== 'Indicadores' && item.data !== 'Data'">

      <!-- up -->
      <img src="../../../../assets/svgs/icon_order_up.svg" alt="Seta para baixo" 
      *ngIf="(columnId === i && countColumn === 1) && item.data !== 'input' && item.data !== 'Contato' && item.data !== 'Indicadores' && item.data !== 'Data'">

      <!-- down -->
      <img src="../../../../assets/svgs/icon_order_down.svg" alt="Seta para baixo" 
      *ngIf="(columnId === i && countColumn === 2) && item.data !== 'input' && item.data !== 'Contato' && item.data !== 'Indicadores' && item.data !== 'Data'">
    </div>
  </div>
  <div class="table">

    <div class="tbl-name tbl" [class.tbl-name__v2]="!featureV2">
      <div id="tbl-name-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index" 
        [ngClass]="{'green': data.color === 1, 'red': data.color === 2, 'yellow': data.color === 3, 'tbl-hover': id === i + 1}"
        (mouseover)="hoverEvent(i)" (click)="openModalTable($event, true, data)">
        <lib-input-checkbox class="input-control" id="favorite" name="favorite" [(ngModel)]="data.select" 
        (click)="openModalTable($event, false, null); getClickItem(i)" *ngIf="featureV2 && isCheckbox"></lib-input-checkbox>
        <p [matTooltip]="data.name">{{ data.name }}</p>
      </div>
    </div>

    <div class="tbl-product tbl">
      <div id="tbl-product-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index"
      [ngClass]="{'tbl-hover': id === i + 1}"
      (click)="openModalTable($event, true, data)"
      (mouseover)="hoverEvent(i)">
        <p><span [matTooltip]="data.product">{{ data.product ? data.product : 'Sem produto' }}</span></p>
      </div>
    </div> 

    <div class="tbl-stage tbl">
      <div id="tbl-stage-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index" 
      [ngClass]="{'tbl-hover': id === i + 1}"
      (click)="openModalTable($event, true, data)"
      (mouseover)="hoverEvent(i)">
        <p [matTooltip]="data.funnel_stage.value + data.interest ? data.interest : null">{{ data.funnel_stage.value + (data.interest ? ': ' + data.interest : '') }}</p>
      </div>
    </div>

    <!-- // corretor -->
    <div class="tbl-broker tbl" *ngIf="featureV2">
      <div id="tbl-stage-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index" 
      [ngClass]="{'tbl-hover': id === i + 1}"
      (click)="openModalTable($event, true, data)"
      (mouseover)="hoverEvent(i)">
        <p>{{ data.user_nickname }}</p>
      </div>
    </div> 

    <div class="tbl-contact tbl">
      <div id="tbl-contact-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index" 
      [ngClass]="{'tbl-hover': id === i + 1}"
      (click)="openModalTable($event, true, data)"
      (mouseover)="hoverEvent(i)">
        <button class="btn btn-phone" id="btn-phone-{{data.id}}" 
        [matTooltip]="data.phone.ddi + ' ' + data.phone.phone"        
        (click)="copyToClipboard(data.phone.ddi + '' + data.phone.phone, 'Telefone'); openModalTable($event, false, data)">
          <p hidden=true>{{ data.phone.ddi }} {{ data.phone.phone }}</p>
          <img src="../../../../assets/svgs/i_phone.svg" alt="Icon Phone">
        </button>
        <button class="btn btn-email" id="btn-email-{{data.id}}" 
        [matTooltip]="data.email" 
        (click)="copyToClipboard(data.email, 'Email'); openModalTable($event, false, data)">
          <p hidden=true>{{ data.emaiil }}</p>
          <img src="../../../../assets/svgs/i_email.svg" alt="Icon Email">
        </button>
      </div>
    </div>

    <div class="tbl-temp tbl">
      <div id="tbl-temp-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index" 
        [ngClass]="{'tbl-hover': id === i + 1}"
        (click)="openModalTable($event, true, data)"
        (mouseover)="hoverEvent(i)">
        <img *ngIf="data.temperature === 'Quente'" src="../../../../assets/svgs/i_summer.svg" alt="Icone Quente">
        <img *ngIf="data.temperature === 'Morno'" src="../../../../assets/svgs/i_warm.svg" alt="Icone Morno">
        <img *ngIf="data.temperature === 'Frio'"  src="../../../../assets/svgs/i_cold.svg" alt="Icone Frio">
      </div>
    </div>

    <div class="tbl-indicators tbl">
      <div id="tbl-indicators-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding;let i = index"
      [ngClass]="{'tbl-hover': id === i + 1}"
      (click)="openModalTable($event, true, data)"
      (mouseover)="hoverEvent(i)">
        <div class="badges" *ngFor="let badge of data.badges">
          <img *ngIf="badge.name.toLowerCase() === 'stand'" [matTooltip]="badge.description" src="../../../../assets/svgs/stand_fac_ico.svg" alt="Icone Stand">
          <img *ngIf="badge.name.toLowerCase() === 'bought'" [matTooltip]="badge.description" src="../../../../assets/svgs/bought_fac_ico.svg" alt="Icone Dinheiro">
          <img *ngIf="badge.name.toLowerCase() === 'real_state_developer_seller'" [matTooltip]="badge.description" src="../../../../assets/svgs/incorporator_fac_ico.svg" alt="Icone Incorporador">
        </div>
      </div>
    </div>

    <div class="tbl-action tbl">
      <div id="tbl-action-item-{{i}}" class="tbl-body" *ngFor="let item of listBinding; let i = index" 
        [ngClass]="{'tbl-hover': id === i + 1}"
        (click)="openModalTable($event, true, item)"
        (mouseover)="hoverEvent(i);">
        <p *ngIf="item.last_update_date">Atualização: {{ item.last_update_date | date:'dd/MM/yy HH:mm' }}</p>
        <p *ngIf="item.date_return && (!item.last_update_date && !item.visit_date && item.contact)">Retorno: {{ item.date_return }}</p>
        <p *ngIf="item.visit_date && (!item.last_update_date && !item.date_return)">Visita: {{ item.visit_date | date:'dd/MM/yy HH:mm'}}</p>
        <p *ngIf="item.contact && (!item.last_update_date && !item.date_return && !item.visit_date)">Contato: {{ item.contact | date:'dd/MM/yy HH:mm'}}</p>
      </div>
    </div>

  </div>
  <div class="loader" [class.loader__center]="isOrder" *ngIf="loader || isOrder">
    <lib-loading></lib-loading>
  </div>
</div>

